import React from 'react'
import logo from '../images/header-canfax.png'
import {Button} from 'react-bootstrap'
import {connect} from 'react-redux'
import {updateUserAcceptedToS} from '../actions'

@connect()
export default class ToS extends React.Component {
  handleAccept = () => {
    const {dispatch} = this.props
    dispatch(updateUserAcceptedToS())
  }

  handleDecline = () => {
    window.alert('You must accept the Terms of Service to Use this app!')
  }

  render() {
    return (
      <div className="content" style={{textAlign: 'center'}}>
        <img
          src={logo}
          alt="CanFax Logo"
          style={{paddingTop: '10px', paddingBottom: '10px'}}
        />
        <p style={{color: 'white', fontSize: '18px'}}>
          Canfax tries to provide quality information, but we make no claims,
          promises, or guarantees about the accuracy, completeness, or adequacy
          of the information. Calculations in this App are based on industry
          benchmarks, it is the responsibility of the user to check all
          assumptions and calculations. Canfax does not guarantee, and accepts
          no legal liability arising from or connected to, the accuracy,
          reliability, or completeness of any material contained in this App.
          The use of this App, and calculations is for personal use only.
          Reproduction and/or electronic transmission of the information, in
          whole or in part, is strictly forbidden without written consent from
          Canfax.
        </p>
        <Button onClick={this.handleAccept} className="btn btn-success mx-1">
          Accept
        </Button>
        <Button onClick={this.handleDecline} className="btn btn-danger mx-1">
          Decline
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tos.js